'use client';
import Image from'next/image';
 import Button from'@/components/ui/Button';
import Link from 'next/link';

const HeroSection = () => {
  return (
    <section className="w-full bg-background-main relative">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ backgroundImage: "url('/images/banner-img.webp')", backgroundPosition: 'top' }}
      />
      
<div className="relative z-10 w-full max-w-[1340px] mx-auto px-6 sm:px-16 lg:px-12 pt-[12%] sm:pt-[12%] lg:pt-[7%]">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-16 py-16 lg:py-24">
          {/* Left Content */}
          <div className="flex flex-col gap-8 lg:gap-16 justify-start items-start w-full lg:flex-1">
            <div className="flex flex-col gap-4 lg:gap-[26px] justify-start items-start w-full">
              <h1 className="text-[30px] sm:text-[40px] md:text-[50px] lg:text-[59px] font-extrabold leading-[32px] sm:leading-[44px] md:leading-[54px] lg:leading-7xl text-left text-text-darkest w-full lg:w-[92%]">
                AI meets Empowered Women
              </h1>
              <p className="text-base sm:text-lg lg:text-lg font-normal leading-6 sm:leading-7 lg:leading-3xl text-left text-text-light w-full lg:w-[94%] font-normal">
                Welcome to EmpowHER in AI. We are building a powerful community of women founders, operators, and innovators shaping the future of AI.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row justify-start items-center gap-4 sm:gap-[18px] w-full">
            {/* Join the Community Button */}
             <Link href='https://lu.ma/empowherin_ai?k=c' rel="noopener noreferrer nofollow" target='_blank'>
            <Button
              text_font_size="text-base"
              text_font_family="HelveticaNeue"
              text_font_weight="medium"
              text_line_height="leading-[24px]"
              text_text_align="center"
              text_color="text-white"
              fill_background_color="bg-[#FA4B80]" // Adjust to your theme's primary-dark
              border_border_radius="rounded-sm"
              padding="py-[14px] px-[22px] pr-[36px]"
              className="flex items-center gap-[6px] font-500 py-[14px] px-[22px] pr-[36px] hover:bg-black transition-colors duration-200 w-full sm:w-auto"
            >
              <span className="text-white">Join the </span>
              <span className="text-[#fff]">Community</span>
              <Image
                src="/images/img-line-rounded-arrow-rigth.webp"
                alt="Arrow"
                width={14}
                height={14}
                unoptimized
                className="ml-1"
              />
            </Button>
            </Link>
              {/* Become a Member Button */}
               <Link href='http://t.me/EmpowHERinAI' rel="noopener noreferrer nofollow" target='_blank'>
              <Button
                text="Become a Member"
                text_font_size="text-base"
                text_font_family="HelveticaNeue"
                text_font_weight="font-medium"
                text_line_height="leading-[24px]"
                text_text_align="center"
                text_color="text-[#1E1E1E]" // dark text
                fill_background_color="bg-transparent"
               border_border_radius="rounded-sm"
                className="font-helvetica hover:bg-[#FA4B7F] border-2 border-[#FA4B7F] py-[14px] px-[22px] pr-[36px] hover:text-white transition-colors duration-200 w-full sm:w-auto"
              />
               </Link>
            </div>

          </div>
          
          {/* Right Images Grid */}
          <div className="flex flex-col gap-4 lg:gap-[24px] justify-start items-center w-full lg:w-[48%]">
            <div className="flex flex-row gap-6 lg:gap-[40px] justify-center items-center w-full">
              <Image
                src="/images/img-image-45.webp"
                alt="Empowered Woman 1"
                width={296}
                height={296}
                className="w-[200px] h-[200px] sm:w-[240px] sm:h-[240px] lg:w-[296px] lg:h-[296px] rounded-md object-cover"
                unoptimized
              />
              <Image
                src="/images/img-image-48.webp"
                alt="Empowered Woman 2"
                width={202}
                height={202}
                className="w-[140px] h-[140px] sm:w-[170px] sm:h-[170px] lg:w-[202px] lg:h-[202px] rounded-md object-cover self-end mb-4 lg:mb-[26px]"
                unoptimized
              />
            </div>
            
            <div className="flex flex-row justify-end items-start w-full px-4 lg:px-[28px]">
              <Image
                src="/images/img-image-39.webp"
                alt="Empowered Woman 3"
                width={172}
                height={170}
                className="w-[120px] h-[118px] sm:w-[146px] sm:h-[144px] lg:w-[172px] lg:h-[170px] rounded-md object-cover"
                unoptimized
              />
              <Image
                src="/images/img-image-34.webp"
                alt="Empowered Woman 4"
                width={190}
                height={190}
                className="w-[130px] h-[130px] sm:w-[160px] sm:h-[160px] lg:w-[190px] lg:h-[190px] rounded-md object-cover self-center ml-6 lg:ml-[48px]"
                unoptimized
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroSection